import useSnackbar from './useSnackbar';

type UseFileDownloadOptions = {
  successMessage?: string;
  errorMessage?: string;
};

const useFileDownload = (options: UseFileDownloadOptions = {}) => {
  const { openSnackbar } = useSnackbar();
  const {
    successMessage = 'File downloaded successfully',
    errorMessage = 'Failed to download file',
  } = options;

  const downloadFile = async (response: Response, filename: string) => {
    if (!response.ok) {
      openSnackbar({
        message: errorMessage,
        variant: 'error',
        autoHide: true,
        duration: 3000,
      });
      return;
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(blobUrl);
    a.remove();
    openSnackbar({
      message: successMessage,
      variant: 'success',
      autoHide: true,
      duration: 3000,
    });
  };

  return { downloadFile };
};

export default useFileDownload;
